import React from "react";

export default props => {

    return <div>
        {
            props.loading
                ? <div className="d-flex align-items-center justify-content-center vh-100">
                    <div className="d-flex flex-column">
                        <div className="spinner-border text-primary" role="status" />
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
                : props.children
        }
    </div>
}


// WEBPACK FOOTER //
// ./src/_components/LoadingContainer/index.jsx